export default __webpack_public_path__ + "static/media/girl-at-a-canyon.bce034e0.jpg";